/**
 * Runtime environment helpers (local vs production).
 * Values come from .env.development / .env.production via Vite.
 */

/** @typedef {'local' | 'production'} AppEnvironment */

/** @returns {AppEnvironment} */
export function getAppEnv() {
  const env = import.meta.env.VITE_APP_ENV;
  return env === 'production' ? 'production' : 'local';
}

export function isLocalEnv() {
  return getAppEnv() === 'local';
}

export function isProductionEnv() {
  return getAppEnv() === 'production';
}

export function firebaseEmulatorsEnabled() {
  return import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
}

/** @deprecated Use firebaseEmulatorsEnabled — not a React hook. */
export const useFirebaseEmulators = firebaseEmulatorsEnabled;

export function getBuildMode() {
  return import.meta.env.MODE;
}
